import React from 'react'
import "./Footer.css"
import Data from "../Data/Data"
import { PiInstagramLogoLight } from "react-icons/pi";
import { BiLogoWhatsapp } from "react-icons/bi";
import { CiLinkedin } from "react-icons/ci";
import { PiCopyright } from "react-icons/pi";

const Footer = () => {
    return (
        <div className='footer-main'>
            <div className="footer-container">

                <div className="footer-top">

                    {/* ---- Brand column ---- */}
                    <div className="footer-line-1">
                        <div className="footer-logo">
                            <img src={Data.logo} alt="" />
                        </div>
                        <div className="footer-about">
                            <p>A Business Associate of Motilal Oswal, based in Patiala, Punjab. Where wealth begins.</p>
                        </div>
                      
                    </div>

                    {/* ---- Explore column ---- */}
                    <div className="footer-line-2">
                        <div className="footer-heading">
                            <h1>Explore</h1>
                        </div>
                        <div className="footer-links">
                            <a href="#home">Home</a>
                            <a href="#about">About</a>
                            <a href="#ser">Services</a>
                            <a href="#pro">Why US</a>
                            <a href="#pro">Process</a>
                        </div>
                    </div>

                    {/* ---- Contact column ---- */}
                    <div className="footer-line-3">
                        <div className="footer-heading">
                            <h1>Contact</h1>
                        </div>
                        <div className="footer-links-1">
                            <span>Patiala, Punjab, India</span>
                            <span1>+91 96465 55699</span1>
                            <span2>profitstation99@gmail.com</span2>
                        </div>
                    </div>

                    {/* ---- Follow Us column ---- */}
                    <div className="footer-line-4">
                        <div className="footer-heading">
                            <h1>Follow Us</h1>
                        </div>
                        <div className="footer-links">
                            <a 
                                href="https://www.instagram.com/profit_station99" 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                Instagram
                            </a>
                            <a 
                                href="https://wa.me/9646555699" 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                WhatsApp
                            </a>
                            <a 
                                href="https://www.linkedin.com/in/manoj-palta-5aa043405" 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                LinkedIn
                            </a>
                        </div>
                    </div>

                </div>

                <div className="footer-line" />

                <div className="footer-down">
                    <div className="footer-d-left">
                        <span><PiCopyright /> 2026 Profi1 Station. All rights reserved.</span>
                    </div>
                    <div className="footer-d-right">
                        <span>Business Associate of Motilal Oswal Financial Services Ltd.</span>
                    </div>
                </div>

                <div className="footer-end">
                    <p>Investments in securities markets are subject to market risks. Read all related documents carefully before investing. Profi1 Station is a Business Associate of Motilal Oswal and is not a SEBI-registered entity in its own right; all trades are executed through Motilal Oswal Financial Services Ltd.</p>
                </div>

            </div>
        </div>
    )
}

export default Footer